import styled from 'styled-components'

export const StyledMedicalRecordReportTypeFilterWrapper = styled.div`
    width: fit-content;
    min-width: 250px;
`
